// src/pages/Profile.js
import React, { useContext } from 'react';
import { AuthContext } from '../store/authContext';
import { User, AtSign, Shield, LogOut } from 'lucide-react';

const Profile = () => {
  const { currentUser, logout } = useContext(AuthContext);

  const handleLogout = async () => {
    const result = await logout();
    if (result.success !== false) {
      // Redirecionar manualmente ou já faz no ProtectedRoute
      // ex: window.location.href = '/login';
    }
  };

  if (!currentUser) {
    return (
      <div className="p-6 bg-gray-50 min-h-screen">
        <p className="text-gray-500">Carregando...</p>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
        <User className="h-6 w-6 mr-2 text-blue-600" />
        Meu Perfil
      </h1>
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex items-center space-x-4 mb-6">
          <div className="h-14 w-14 rounded-full bg-blue-600 text-white flex items-center justify-center text-xl font-bold uppercase">
            {currentUser.name?.charAt(0)}
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-700">{currentUser.name}</h2>
            <p className="text-sm text-gray-500 flex items-center">
              <AtSign className="h-4 w-4 mr-1" />
              {currentUser.email}
            </p>
            <p className="text-sm text-gray-500 flex items-center mt-1">
              <Shield className="h-4 w-4 mr-1" />
              {currentUser.role || 'Usuário Básico'}
            </p>
          </div>
        </div>

        {/* Informações adicionais, se existirem */}
        <div className="space-y-4 text-sm text-gray-600">
          <p><strong>ID:</strong> {currentUser.id}</p>
          <p><strong>Criado em:</strong> {new Date(currentUser.created_at).toLocaleDateString()}</p>
          <p><strong>Bio:</strong> {currentUser.bio || 'Nenhuma bio cadastrada.'}</p>
        </div>

        <hr className="my-6" />

        {/* Botão de Logout */}
        <button
          onClick={handleLogout}
          className="btn-danger flex items-center"
        >
          <LogOut className="h-4 w-4 mr-2" />
          Sair
        </button>
      </div>
    </div>
  );
};

export default Profile;
